<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useDisciplineStore } from '../model/store'
import { useDisciplineRefresh } from '../model/discipline-refresh.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import DisciplineReport from './DisciplineReport.vue'

defineOptions({
  name: 'DisciplineReportPage',
})

const disciplineStore = useDisciplineStore()
const { refreshDiscipline } = useDisciplineRefresh()

useOnTimezoneChange(() => {
  void refreshDiscipline()
})
</script>

<template>
  <DisciplinePageLoader />
  <DisciplineReport
    v-if="disciplineStore.hasDetails"
  />
</template>
